import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Button, CardTitle, CardSubtitle, Label, Input, Container, Form, FormFeedback, UncontrolledAlert, Spinner, FormGroup } from "reactstrap";
import { get, post } from "../../../Services/RestAPIService";
import { useParams, useNavigate } from 'react-router-dom';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from 'react-i18next';
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const CreateVideos = () => {
    const animatedComponents = makeAnimated();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [exerciseImage, setExerciseImage] = useState(null);
    const [activitiesSelected, setActivitiesSelected] = useState([]);
    const [activities, setActivities] = useState([
        { value: 'Walking', label: t('activities.walking') },
        { value: 'Running', label: t('activities.running') },
        { value: 'Swimming', label: t('activities.swimming') },
        { value: 'Cycling', label: t('activities.cycling') }
    ]);
    const [occupationsSelected, setOccupationsSelected] = useState([]);
    const [occupations, setOccupations] = useState([
        { value: 'Construction', label: t('occupations.construction') },
        { value: 'Sports', label: t('occupations.sports') },
        { value: 'Services and Hospitality', label: t('occupations.services') },
        { value: 'Office/Remote Work', label: t('occupations.office') },
        { value: 'Education', label: t('occupations.education') }
    ]);
    const [videoLink, setVideoLink] = useState('');
    const [videoPlatform, setVideoPlatform] = useState('YouTube');
    const [exerciseWhileStanding, setExerciseWhileStanding] = useState(false);
    const [exerciseWhileLying, setExerciseWhileLying] = useState(false);
    const [frequency, setFrequency] = useState('Daily');
    const { subid, exeid, id } = useParams();
    const navigate = useNavigate();
    const [alert, setAlert] = useState({
        color: "",
        message: "",
        visible: false
    });
    const [dataOriginal, setDataOriginal] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [subcategoriesMap, setSubcategoriesMap] = useState({});
    const [selectedSubcategories, setSelectedSubcategories] = useState({});
    const [exercisesMap, setExercisesMap] = useState({});
    const [selectedExercises, setSelectedExercises] = useState({});
    const [difficulty, setDifficulty] = useState('easy');

    const getUsersData = async () => {
        try {
            const usersData = await get(`category/categories/?parent_id_isnull=true`);
            if (usersData) {
                let formattedData = usersData.results.map((category) => ({
                    label: category.name,
                    value: category.id.toString(),
                }));
                setDataOriginal(formattedData);
                if (subid && subid !== "id") {
                    const selected = formattedData.filter(cat => cat.value === subid);
                    setSelectedCategories(selected);
                    selected.forEach(cat => fetchSubcategories(cat.value));
                }
            } else {
                console.error('No data found in the response.');
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };


    const fetchSubcategories = async (parentId) => {
        try {
            const SubcatData = await get(`category/categories/?parent_id=${parentId}`);
            if (SubcatData) {
                let formattedDataSubCat = SubcatData.results.map((category) => ({
                    label: category.name,
                    value: category.id.toString(),
                }));
                setSubcategoriesMap(prev => ({
                    ...prev,
                    [parentId]: formattedDataSubCat
                }));
                if (exeid && exeid !== "id") {
                    const selected = formattedDataSubCat.filter(subcat => subcat.value === exeid);
                    setSelectedSubcategories(prev => ({
                        ...prev,
                        [parentId]: selected
                    }));
                    selected.forEach(subcat => fetchExercises(parseInt(subcat.value)));
                }
            } else {
                console.error('No data found in the response.');
            }
        } catch (error) {
            console.error('Error fetching subcategory data:', error);
        }
    };


    const fetchExercises = async (subcategoryId) => {
        console.log(subcategoryId,"subcategoryId")

        try {
            const ExerciseData = await get(`exercise/exercises/?categories=${subcategoryId}&page_size=1000`);

            console.log(ExerciseData,"ExerciseData")
            if (ExerciseData) {
                let formattedDataExercise = ExerciseData.results.map((category) => ({
                    label: category.exercise_name,
                    value: category.id.toString(),
                }));
                setExercisesMap(prev => ({
                    ...prev,
                    [subcategoryId]: formattedDataExercise
                }));
                if (id && id !== "id") {
                    const selected = formattedDataExercise.filter(ex => ex.value === id);
                    setSelectedExercises(prev => ({
                        ...prev,
                        [subcategoryId]: selected
                    }));
                }
            } else {
                console.error('No data found in the response.');
            }
        } catch (error) {
            console.error('Error fetching exercise data:', error);
        }
    };

    const handleParentChange = (selected) => {
        setSelectedCategories(selected);
        selected.forEach((cat) => {
            if (!subcategoriesMap[cat.value]) {
                fetchSubcategories(cat.value);
            }
        });
        const updatedSubcategories = {};
        const updatedExercises = {};
        selected.forEach((cat) => {
            if (selectedSubcategories[cat.value]) {
                updatedSubcategories[cat.value] = selectedSubcategories[cat.value];
                selectedSubcategories[cat.value].forEach((subcat) => {
                    if (selectedExercises[subcat.value]) {
                        updatedExercises[subcat.value] = selectedExercises[subcat.value];
                    }
                });
            }
        });
        setSelectedSubcategories(updatedSubcategories);
        setSelectedExercises(updatedExercises);
    };

    const handleSubcategoryChange = (parentId, selected) => {
        setSelectedSubcategories(prev => ({
            ...prev,
            [parentId]: selected
        }));
        selected.forEach((subcat) => {
            if (!exercisesMap[subcat.value]) {
                fetchExercises(subcat.value);
            }
        });
        const updatedExercises = {};
        selected.forEach((subcat) => {
            if (selectedExercises[subcat.value]) {
                updatedExercises[subcat.value] = selectedExercises[subcat.value];
            }
        });
        setSelectedExercises(updatedExercises);
    };

    useEffect(() => {
        getUsersData();
    }, []);

    const validation = useFormik({
        initialValues: {
            title: '',
            description: '',
            video: videoLink,
            activities: [],
            frequency: frequency,
            occupation: [],
            exercise_while_standing: exerciseWhileStanding,
            exercise_while_lying: exerciseWhileLying,
            exerciseData: [],
        },
        validationSchema: Yup.object({
            title: Yup.string().required(t("Please Enter Video Title")),
            description: Yup.string().required(t("Please Enter Description")),
            video: Yup.string().url(t("Invalid URL format")).required(t("Please Enter Video Link")),
            activities: Yup.array().min(1, t("Please select at least one activity")),
            frequency: Yup.string().required(t("Please select frequency")),
            occupation: Yup.array().min(1, t("Please select at least one occupation")),
            exercise_while_standing: Yup.boolean().required(t("Please specify if exercises while standing")),
            exercise_while_lying: Yup.boolean().required(t("Please specify if exercises while lying")),
            // exerciseData: id === "id" ? Yup.array().min(1, t('Please select at least one exercise')) : null,
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            const exerciseIds = Object.values(selectedExercises).flat().map(item => Number(item.value));
            const Data = {
                "title": values.title,
                "description": values.description,
                "video": videoLink,
                "activities": values.activities.map(activity => activity.value),
                "frequency": values.frequency,
                "occupation": values.occupation.map(occupation => occupation.value),
                "exercise_while_standing": values.exercise_while_standing,
                "exercise_while_lying": values.exercise_while_lying,


                "exercise_id": exerciseIds[0] || Number(id),
                "exercises": exerciseIds.length > 0 ? exerciseIds : [Number(id)],
                "difficulty":difficulty
            };

            console.log(Data ,"DATA")
            try {
                const response = await post(`exercise/exercises-videos/`, Data, {
                    headers: { 'Content-Type': 'application/json' },
                    validateStatus: false
                });
                if (response.status <= 399) {
                    validation.setValues(validation.initialValues);
                    validation.setErrors({});
                    resetForm();
                    setAlert({
                        color: "success",
                        visible: true,
                        message: t("Video created successfully!")
                    });
                    setTimeout(() => {
                        navigate(`/category/videos/${subid === "id" ? selectedSubcategories[Object.keys(selectedSubcategories)[0]]?.[0]?.value || subid : subid}/${exeid === "id" ? exerciseIds[0] || exeid : exeid}/${id === "id" ? exerciseIds[0] : id}`);
                    }, 1500);
                } else {
                    let errorMessage = t("An error occurred while creating video.");
                    for (const key in response.data) {
                        if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
                            errorMessage = `${key}: ${response.data[key][0]}`;
                            break;
                        }
                    }
                    setAlert({
                        color: "danger",
                        visible: true,
                        message: errorMessage
                    });
                }
            } catch (error) {
                console.error('Error creating video:', error);
                setAlert({
                    color: "danger",
                    visible: true,
                    message: t("An error occurred while creating video.")
                });
            } finally {
                setIsLoading(false);
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);
            }
        }
    });

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setExerciseImage(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleVideoLinkChange = (event) => {
        setVideoLink(event.target.value);
        validation.setFieldValue('video', event.target.value);
    };

    const handleFrequencyChange = (event) => {
        setFrequency(event.target.value);
        validation.setFieldValue('frequency', event.target.value);
    };

    const handleExerciseWhileStandingChange = (event) => {
        const value = event.target.value === 'Yes';
        setExerciseWhileStanding(value);
        validation.setFieldValue('exercise_while_standing', value);
    };

    const handleExerciseWhileLyingChange = (event) => {
        const value = event.target.value === 'Yes';
        setExerciseWhileLying(value);
        validation.setFieldValue('exercise_while_lying', value);
    };

    const handleDiff = (event) => {
        console.log(event.target.value,"HGGGGG")
        // const value = event.target.value === 'Yes';
        setDifficulty(event.target.value);
        validation.setFieldValue('exercise_while_lying', value);
    };
    

    const getVideoEmbedUrl = (platform, link) => {
        switch (platform) {
            case 'YouTube':
                return `https://www.youtube.com/embed/${encodeURIComponent(getYoutubeVideoId(link))}`;
            case 'Vimeo':
                return `https://player.vimeo.com/video/${getVimeoVideoId(link)}`;
            default:
                return '';
        }
    };

    const getYoutubeVideoId = (link) => {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = link.match(regex);
        return match ? match[1] : '';
    };

    const getVimeoVideoId = (link) => {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/;
        const match = link.match(regex);
        return match ? match[1] : '';
    };

    return (
        <React.Fragment>
            {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={alert.color}>{alert.message}</UncontrolledAlert>}
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs maintitle={t("Home")} title={t("Exercise Videos")} titleLink={`/category/videos/${subid === "id" ? selectedSubcategories[Object.keys(selectedSubcategories)[0]]?.[0]?.value || subid : subid}/${exeid === "id" ? Object.values(selectedExercises).flat()[0]?.value || exeid : exeid}/${id === "id" ? Object.values(selectedExercises).flat()[0]?.value || id : id}`} breadcrumbItem={t("Add Videos")} />
                    <Row>
                        <Col lg={6}>
                            <Card>
                                <CardBody>
                                    <CardTitle>{t("Add New Video")}</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {t("Fill in the details below to create a new exercise video.")}
                                    </CardSubtitle>
                                    <Form onSubmit={validation.handleSubmit}>
                                        {/* {id === "id" && ( */}
                                            <>
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{t('Select Parent Category')}</Label>
                                                    <Select
                                                        isMulti
                                                        value={selectedCategories}
                                                        name="parentCategories"
                                                        onChange={handleParentChange}
                                                        onBlur={validation.handleBlur}
                                                        options={dataOriginal}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                    {validation.touched.exerciseData && validation.errors.exerciseData && (
                                                        <FormFeedback type="invalid">{validation.errors.exerciseData}</FormFeedback>
                                                    )}
                                                </FormGroup>
                                                {selectedCategories.map((cat) => (
                                                    <React.Fragment key={cat.value}>
                                                        <FormGroup className="mb-3">
                                                            <Label>
                                                                {t("Select Body Parts for")} <strong>{cat.label}</strong>
                                                            </Label>
                                                            <Select
                                                                isMulti
                                                                name={`bodyParts-${cat.value}`}
                                                                options={subcategoriesMap[cat.value] || []}
                                                                value={selectedSubcategories[cat.value] || []}
                                                                onChange={(selected) => handleSubcategoryChange(cat.value, selected)}
                                                                classNamePrefix="select2-selection"
                                                            />
                                                        </FormGroup>
                                                        {(selectedSubcategories[cat.value] || []).map((subcat) => (
                                                            <FormGroup key={subcat.value} className="mb-3">
                                                                <Label>
                                                                    {t("Select Exercises for")} <strong>{subcat.label}</strong>
                                                                </Label>
                                                                <Select
                                                                    isMulti
                                                                    name={`exercises-${subcat.value}`}
                                                                    options={exercisesMap[subcat.value] || []}
                                                                    value={selectedExercises[subcat.value] || []}
                                                                    onChange={(selected) => setSelectedExercises(prev => ({
                                                                        ...prev,
                                                                        [subcat.value]: selected
                                                                    }))}
                                                                    classNamePrefix="select2-selection"
                                                                />
                                                            </FormGroup>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </>
                                        {/* )} */}
                                        <div className="mb-3">
                                            <Label className="form-label">{t("Video Title")}</Label>
                                            <Input
                                                name="title"
                                                type="text"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.title || ""}
                                                invalid={validation.touched.title && validation.errors.title}
                                            />
                                            {validation.touched.title && validation.errors.title && (
                                                <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">{t("Description")}</Label>
                                            <Input
                                                type="textarea"
                                                name="description"
                                                rows="5"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.description || ""}
                                                invalid={validation.touched.description && validation.errors.description}
                                            />
                                            {validation.touched.description && validation.errors.description && (
                                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                            )}
                                        </div>
                                        <Row>
                                            <Col>
                                                <FormGroup className="mb-3 templating-select select2-container">
                                                    <Label className="control-label">{t("Select Activities")}</Label>
                                                    <Select
                                                        value={activitiesSelected}
                                                        isMulti={true}
                                                        onChange={(selectedOptions) => {
                                                            setActivitiesSelected(selectedOptions);
                                                            validation.setFieldValue('activities', selectedOptions);
                                                        }}
                                                        options={activities}
                                                        classNamePrefix="select2-selection"
                                                        closeMenuOnSelect={false}
                                                        components={animatedComponents}
                                                    />
                                                    {validation.touched.activities && validation.errors.activities && (
                                                        <FormFeedback type="invalid" className="d-block">{validation.errors.activities}</FormFeedback>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Select Frequency")}</Label>
                                                    <Input
                                                        type="select"
                                                        name="frequency"
                                                        onChange={handleFrequencyChange}
                                                        value={frequency}
                                                        invalid={validation.touched.frequency && validation.errors.frequency}
                                                    >
                                                        <option value="Daily">{t("Daily")}</option>
                                                        <option value="Occasionally">{t("Occasionally")}</option>
                                                        <option value="Rarely">{t("Rarely")}</option>
                                                        <option value="Never">{t("Never")}</option>
                                                    </Input>
                                                    {validation.touched.frequency && validation.errors.frequency && (
                                                        <FormFeedback type="invalid">{validation.errors.frequency}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        <FormGroup className="mb-3 templating-select select2-container">
                                            <Label className="control-label">{t("Select Occupations")}</Label>
                                            <Select
                                                value={occupationsSelected}
                                                isMulti={true}
                                                onChange={(selectedOptions) => {
                                                    setOccupationsSelected(selectedOptions);
                                                    validation.setFieldValue('occupation', selectedOptions);
                                                }}
                                                options={occupations}
                                                classNamePrefix="select2-selection"
                                                closeMenuOnSelect={false}
                                                components={animatedComponents}
                                            />
                                            {validation.touched.occupation && validation.errors.occupation && (
                                                <FormFeedback type="invalid" className="d-block">{validation.errors.occupation}</FormFeedback>
                                            )}
                                        </FormGroup>
                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Video of Exercises while standing")}</Label>
                                                    <Input
                                                        type="select"
                                                        name="exercise_while_standing"
                                                        onChange={handleExerciseWhileStandingChange}
                                                        value={exerciseWhileStanding ? "Yes" : "No"}
                                                        invalid={validation.touched.exercise_while_standing && validation.errors.exercise_while_standing}
                                                    >
                                                        <option value="Yes">{t("Yes")}</option>
                                                        <option value="No">{t("No")}</option>
                                                    </Input>
                                                    {validation.touched.exercise_while_standing && validation.errors.exercise_while_standing && (
                                                        <FormFeedback type="invalid">{validation.errors.exercise_while_standing}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Video of Exercises while lying down")}</Label>
                                                    <Input
                                                        type="select"
                                                        name="exercise_while_lying"
                                                        onChange={handleExerciseWhileLyingChange}
                                                        value={exerciseWhileLying ? "Yes" : "No"}
                                                        invalid={validation.touched.exercise_while_lying && validation.errors.exercise_while_lying}
                                                    >
                                                        <option value="Yes">{t("Yes")}</option>
                                                        <option value="No">{t("No")}</option>
                                                    </Input>
                                                    {validation.touched.exercise_while_lying && validation.errors.exercise_while_lying && (
                                                        <FormFeedback type="invalid">{validation.errors.exercise_while_lying}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                        <Col>

                                        <div className="mb-3">
                                            <Label className="form-label">{t("Select Video Platform")}</Label>
                                            <Input
                                                type="select"
                                                name="videoPlatform"
                                                onChange={(event) => {
                                                    setVideoPlatform(event.target.value);
                                                    validation.setFieldValue('videoPlatform', event.target.value);
                                                }}
                                                value={videoPlatform}
                                            >
                                                <option value="YouTube">{t("YouTube")}</option>
                                                <option value="Vimeo">{t("Vimeo")}</option>
                                            </Input>
                                        </div>


                                                                                        </Col>

                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Set Difficulty Level")}</Label>
                                                        <Input
                                                        type="select"
                                                        name="difficulty_level"
                                                        onChange={handleDiff}
                                                        value={difficulty}
                                                        // invalid={validation.touched.difficulty_level && validation.errors.difficulty_level}
                                                        >
                                                        <option value="">{t("Select difficulty")}</option>
                                                        <option value="easy">{t("Easy")}</option>
                                                        <option value="medium">{t("Medium")}</option>
                                                        <option value="hard">{t("Hard")}</option>
                                                        </Input>
                                                        {/* {validation.touched.difficulty_level && validation.errors.difficulty_level && ( */}
                                                        {/* // <FormFeedback type="invalid">{validation.errors.difficulty_level}</FormFeedback> */}
                                                        {/* // )} */}
                                                    </div>
                                                    </Col>
                                                </Row>




                                        <div className="mb-3">
                                            <Label className="form-label">{t("Video Link")}</Label>
                                            <Input
                                                type="text"
                                                name="video"
                                                onChange={handleVideoLinkChange}
                                                onBlur={validation.handleBlur}
                                                value={videoLink}
                                                invalid={validation.touched.video && validation.errors.video}
                                            />
                                            {validation.touched.video && validation.errors.video && (
                                                <FormFeedback type="invalid">{validation.errors.video}</FormFeedback>
                                            )}
                                            {videoLink && (
                                                <div className="mt-3">
                                                    <iframe
                                                        width="100%"
                                                        height="315"
                                                        src={getVideoEmbedUrl(videoPlatform, videoLink)}
                                                        frameBorder="0"
                                                        allowFullScreen
                                                        title="Video Preview"
                                                    ></iframe>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex flex-wrap gap-2">
                                            <Button type="submit" color="primary" disabled={isLoading}>
                                                {isLoading ? <Spinner size="sm" color="light" /> : t("Create")}
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default CreateVideos;